import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path=":bioId" element={<App />} />
      </Routes>
    </BrowserRouter>
  );
};

const HomePage = () => {
  const currentUrl = `${window.location.protocol}//${window.location.host}`;
  const exampleUrl = `${currentUrl}/exemplo`;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f5f5f5',
      }}
    >
      <p style={{ color: '#666', textAlign: 'center', maxWidth: '500px' }}>
        Para acessar uma página específica, adicione um ID após a barra na URL
        (ex: /seu-id-aqui).
      </p>
      <div style={{ marginTop: '30px' }}>
        <p style={{ color: '#888', fontSize: '14px' }}>
          Exemplo:{' '}
          <code
            style={{
              backgroundColor: '#e0e0e0',
              padding: '2px 6px',
              borderRadius: '3px',
            }}
          >
            {exampleUrl}
          </code>
        </p>
      </div>
    </div>
  );
};
